// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetAronApiAssetgroupsResponse, GetAronApiAssetgroupByIdData, GetAronApiAssetgroupByIdResponse, GetRadioEpisodesData, GetRadioEpisodesResponse, GetAppApiAudiothekapiGetshowflyoutData, GetAppApiAudiothekapiGetshowflyoutResponse, GetAppApiAudiothekapiGetepisodeflyoutData, GetAppApiAudiothekapiGetepisodeflyoutResponse, GetAronApiLivetickerData, GetAronApiLivetickerResponse, GetAppApiMeteoarticleInvokeResponse, GetAppApiMeteoarticleLegacyteaserResponse, GetAppApiMobileapiPageviewData, GetAppApiMobileapiPageviewResponse, GetAppApiMobileapiPageviewv2Data, GetAppApiMobileapiPageviewv2Response, GetAppApiMobileapiArticleteaserData, GetAppApiMobileapiArticleteaserResponse, GetAppApiMobileapiMostviewedData, GetAppApiMobileapiMostviewedResponse, GetAppApiPortalapiPortalResponse, GetAppApiSocialviewGetData, GetAppApiSocialviewGetResponse, GetAutoboxData, GetAutoboxResponse, GetGameData, GetGameResponse, GetAppApiVisualradioapiSlidesData, GetAppApiVisualradioapiSlidesResponse } from './types.gen';

/**
 * @returns unknown
 * @throws ApiError
 */
export const getAronApiAssetgroups = (): CancelablePromise<GetAronApiAssetgroupsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/assetgroups'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const getAronApiAssetgroupById = (data: GetAronApiAssetgroupByIdData): CancelablePromise<GetAronApiAssetgroupByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/assetgroups/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.page
 * @param data.limit
 * @returns RadioEpisode Pageable list of episodes for a radio show
 * @throws ApiError
 */
export const getRadioEpisodes = (data: GetRadioEpisodesData): CancelablePromise<GetRadioEpisodesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/audio/shows/{id}/latestEpisodes',
    path: {
        id: data.id
    },
    query: {
        page: data.page,
        limit: data.limit
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShowFlyout Data for the show flyout
 * @throws ApiError
 */
export const getAppApiAudiothekapiGetshowflyout = (data: GetAppApiAudiothekapiGetshowflyoutData): CancelablePromise<GetAppApiAudiothekapiGetshowflyoutResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/audio/shows/{id}/flyout',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns RadioEpisode Data for the episode flyout
 * @throws ApiError
 */
export const getAppApiAudiothekapiGetepisodeflyout = (data: GetAppApiAudiothekapiGetepisodeflyoutData): CancelablePromise<GetAppApiAudiothekapiGetepisodeflyoutResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/audio/episodes/{id}/flyout',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.urn
 * @returns unknown
 * @throws ApiError
 */
export const getAronApiLiveticker = (data: GetAronApiLivetickerData): CancelablePromise<GetAronApiLivetickerResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/liveticker/{urn}',
    path: {
        urn: data.urn
    }
}); };

/**
 * @returns MobileTeaser Returns a single weatherwatch or top article
 * @returns void No content when no articles are found
 * @throws ApiError
 */
export const getAppApiMeteoarticleInvoke = (): CancelablePromise<GetAppApiMeteoarticleInvokeResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/meteo/teaser'
}); };

/**
 * @deprecated
 * @returns unknown Returns a single weatherwatch or top article in legacy format
 * @throws ApiError
 */
export const getAppApiMeteoarticleLegacyteaser = (): CancelablePromise<GetAppApiMeteoarticleLegacyteaserResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/meteo/legacy-teaser'
}); };

/**
 * @param data The data for the request.
 * @param data.urn
 * @returns MobilePageView Custom PageView for mobile use
 * @throws ApiError
 */
export const getAppApiMobileapiPageview = (data: GetAppApiMobileapiPageviewData): CancelablePromise<GetAppApiMobileapiPageviewResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/mobile/pageview/v1/{urn}',
    path: {
        urn: data.urn
    }
}); };

/**
 * @param data The data for the request.
 * @param data.urn
 * @returns MobilePageViewV2 Custom PageView for mobile use V2 with audio and articles
 * @throws ApiError
 */
export const getAppApiMobileapiPageviewv2 = (data: GetAppApiMobileapiPageviewv2Data): CancelablePromise<GetAppApiMobileapiPageviewv2Response> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/mobile/pageview/v2/{urn}',
    path: {
        urn: data.urn
    }
}); };

/**
 * @param data The data for the request.
 * @param data.urn
 * @returns MobileTeaser Custom Article Teaser for mobile use
 * @throws ApiError
 */
export const getAppApiMobileapiArticleteaser = (data: GetAppApiMobileapiArticleteaserData): CancelablePromise<GetAppApiMobileapiArticleteaserResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/mobile/articleteaser/v1/{urn}',
    path: {
        urn: data.urn
    }
}); };

/**
 * @param data The data for the request.
 * @param data.limit
 * @returns MostRead Most read articles of SRF News portal
 * @throws ApiError
 */
export const getAppApiMobileapiMostviewed = (data: GetAppApiMobileapiMostviewedData): CancelablePromise<GetAppApiMobileapiMostviewedResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/mobile/mostread/v1',
    query: {
        limit: data.limit
    }
}); };

/**
 * @returns PublicPortal Public Portal Information
 * @throws ApiError
 */
export const getAppApiPortalapiPortal = (): CancelablePromise<GetAppApiPortalapiPortalResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/portals'
}); };

/**
 * @param data The data for the request.
 * @param data.businessUnit
 * @param data.portalName
 * @param data.limit
 * @returns unknown Array of teaserViews of most read articles
 * @throws ApiError
 */
export const getAppApiSocialviewGet = (data: GetAppApiSocialviewGetData): CancelablePromise<GetAppApiSocialviewGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/cms/articles/mostread',
    query: {
        businessUnit: data.businessUnit,
        portalName: data.portalName,
        limit: data.limit
    }
}); };

/**
 * @param data The data for the request.
 * @param data.businessUnit
 * @param data.representation
 * @param data.portalName
 * @param data.limit
 * @returns unknown HTML of teaserViews of most read articles
 * @throws ApiError
 */
export const getAutobox = (data: GetAutoboxData): CancelablePromise<GetAutoboxResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/articles/autobox',
    query: {
        businessUnit: data.businessUnit,
        portalName: data.portalName,
        limit: data.limit,
        representation: data.representation
    }
}); };

/**
 * @param data The data for the request.
 * @param data.sport
 * @param data.event
 * @returns Game Middleware to SwissTxts Sport API
 * @throws ApiError
 */
export const getGame = (data: GetGameData): CancelablePromise<GetGameResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/sport/{sport}/{event}',
    path: {
        sport: data.sport,
        event: data.event
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns VisualRadioSlideshow Visual Radio: Slideshow
 * @throws ApiError
 */
export const getAppApiVisualradioapiSlides = (data: GetAppApiVisualradioapiSlidesData): CancelablePromise<GetAppApiVisualradioapiSlidesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/aron/api/visual-radio/slides/{id}',
    path: {
        id: data.id
    }
}); };